import { useTranslation } from "react-i18next";

export default function SafetyCtaSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="bg-gradient-to-r from-primary-500 to-primary-600 rounded-lg p-8 md:p-12 flex flex-col lg:flex-row items-start lg:items-center gap-8 lg:gap-12">
          <div className="flex-1">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50">
              {t("safety.title")}
            </h2>
            <p className="mt-3 text-sm md:text-base text-background-100 leading-relaxed max-w-2xl">
              {t("safety.text")}
            </p>
          </div>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="shrink-0 whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-md bg-background-50 text-primary-700 font-bold text-base hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className="ri-external-link-line"></i>
            {t("cta.buynow")}
          </a>
        </div>

        <div className="mt-8 flex items-start gap-3 bg-background-100 border border-background-200/70 rounded-lg p-5">
          <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 shrink-0">
            <i className="ri-information-line"></i>
          </span>
          <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
            {t("safety.disclaimer")}
          </p>
        </div>
      </div>
    </section>
  );
}